export const CRM_RECENT_ACTION_ROLES = ['OWNER', 'ADMIN'];
export const CRM_RECENT_ACTION_EXPORT_LIMIT = 5000;
export const CRM_RECENT_ACTION_DEFAULT_DAYS = 30;
export const CRM_RECENT_ACTION_EXPORT_RATE_LIMIT = { max: 10, timeWindow: '1 minute' };
export function canReadCrmRecentActions(roleKey) {
    return CRM_RECENT_ACTION_ROLES.some((role) => role === roleKey);
}
/** Only these field groups are projected; original audit values remain internal. */
export const CRM_ACTION_FIELD_GROUPS = {
    companyName: 'name',
    tradingName: 'name',
    firstName: 'name',
    lastName: 'name',
    title: 'name',
    email: 'contact',
    phone: 'contact',
    mobile: 'contact',
    fax: 'contact',
    website: 'contact',
    street: 'address',
    postalCode: 'address',
    city: 'address',
    countryCode: 'address',
    region: 'address',
    status: 'status',
    isPrimary: 'status',
    isDefault: 'status',
    deletedAt: 'status',
    isCustomer: 'status',
    isProspect: 'status',
    isSupplier: 'status',
    paymentTermsId: 'conditions',
    paymentTermsDays: 'conditions',
    priceGroup: 'conditions',
    priceGroupId: 'conditions',
    cashDiscountPercent: 'conditions',
    cashDiscountDays: 'conditions',
    deliveryTermsId: 'conditions',
    ownerUserId: 'assignment',
    responsibleUserId: 'assignment',
    assignedUserId: 'assignment',
    assignedTeamId: 'assignment',
    claimedById: 'assignment',
    dueAt: 'dueDate',
    followUpAt: 'dueDate',
    followUpDoneAt: 'result',
    subject: 'note',
    body: 'note',
    note: 'note',
    summary: 'note',
    notes: 'note',
    pinned: 'note',
    visibility: 'note',
    reason: 'note',
    resultSummary: 'result',
    outcome: 'result',
    outcomeOccurredAt: 'result',
    completedAt: 'result',
    completedById: 'result',
    isCompleted: 'result',
    customFields: 'customFields',
    type: 'activity',
    direction: 'activity',
    occurredAt: 'activity',
    durationSeconds: 'activity',
    contactId: 'contact',
};
//# sourceMappingURL=crm-recent-actions.js.map